export const SHIPMENT_ID_990 = 1071519
export const SHIPMENT_ID_214 = 128775
export const INVOICE_ID_210 = 292701
export const CHANGED_FIELD = 'arrived_at'
export const CHANGED_STOP = 1
export const MESSAGE_TYPE_990 = '990'
export const MESSAGE_TYPE_214 = '214'
export const MESSAGE_TYPE_210 = '210'
export const OUTBOUND_EDI_MAPPER_990 = '32'
export const OUTBOUND_EDI_MAPPER_210 = '32'
export const OUTBOUND_EDI_MAPPER_214 = '32'
